import { deserialzeQueryStringToObject } from "GlobalUtils/Common";
import { isDesktop } from "GlobalUtils/DeviceDetection";
import { Application } from "GlobalEnum/Application";

export const isQueryParamsValid = queryString => {
  const queryObj = deserialzeQueryStringToObject(queryString);
  const { encryptedLeadId, leadId, applicationId, isLandingPage } = queryObj;
  if (encryptedLeadId && isDesktop()) {
    // desktop mla reco flow
    return false;
  }
  if (
    leadId ||
    encryptedLeadId ||
    (applicationId == Application.Bikewale && !isLandingPage)
  ) {
    return true;
  }
  return false;
};
